module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[59]546.4cdd281.woff2";